
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import { loadWidget } from '@/utils/helpers';
import Component, { mixins } from 'vue-class-component';
import { Getter, namespace } from 'vuex-class';
import { ICreditBalance } from '@/types/types';

const paymentModule = namespace('payments');

@Component({
  name: 'PaymentSuccess',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
  },
})
export default class PaymentSuccess extends mixins(WidgetMixins, DialogMixins) {
  @Getter('getCreditBalance') creditBalance!: ICreditBalance;
  @paymentModule.Getter('getPaymentResponse') paymentDetails!: {
    status: string;
    amount: number;
    reference: string;
  };

  created(): void {
    // Check if payment details exist, otherwise redirect to dashboard
    if (!this.paymentDetails.reference) {
      this.$router.push('/dashboard');
    }

    // Update credit balance
    this.$store.dispatch('checkCreditBalance', null, { root: true });
  }
}
